import { render, staticRenderFns } from "./vCuenta.vue?vue&type=template&id=25ca1572&scoped=true&"
import script from "./vCuenta.vue?vue&type=script&lang=js&"
export * from "./vCuenta.vue?vue&type=script&lang=js&"
import style0 from "./vCuenta.vue?vue&type=style&index=0&id=25ca1572&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ca1572",
  null
  
)

export default component.exports